import axios from 'axios';

import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import {URL} from '../root';

const FUNCTION_CODE = 'DELETE_ACTIVITY_TYPES';

export async function deleteActivityTypes(userData: Record<string, string>, activityTypesId: number | string) {
    try {
        const response = await axios.delete(
            `${URL}/activity-types/${activityTypesId}/`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userData.userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression du type d\'activité',
            error: error
        });
    }
}
